<script>
import { app } from '@/main'
import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapState, mapActions } from 'vuex'
import { phoneValidator } from '@/support/customValidators/phoneValidator'
import { cnpjValidator, sanitizeCnpj } from '@/support/customValidators/cnpjValidator'

const TRANSLATION = {
  feedback: {
    create: {
      success: app.$t('community.users:register.success'),
      duplicatedUsername: app.$t('community.users:feedback.created.duplicated_username')
    },
    update: {
      success: app.$t('community.users:update.success'),
      addressNotFound: app.$t('community.users:feedback.updated.address_not_found'),
      invalidCurrentPassword: app.$t('community.users:feedback.updated.invalid_current_password')
    },
    save: {
      userNotFound: app.$t('community.users:feedback.updated.user_not_found'),
      duplicatedEmail: app.$t('global:form.validation.email'),
      usernameIsntComposite: app.$t('community.users:feedback.save.username_composite'),
      validationError: app.$t('users.manage:validation.error')
    },
    error: app.$t('global.error')
  }
}

const CREATE_ERRORS_TYPE = {
  user_already_exists: TRANSLATION.feedback.create.duplicatedUsername,
  email_already_exists: TRANSLATION.feedback.save.duplicatedEmail,
  user_name_is_not_composite: TRANSLATION.feedback.save.usernameIsntComposite,
  validation_error: TRANSLATION.feedback.save.validationError,
  default: TRANSLATION.feedback.error
}

const UPDATE_ERRORS_TYPE = {
  user_not_exists: TRANSLATION.feedback.save.userNotFound,
  duplicated_email: TRANSLATION.feedback.save.duplicatedEmail,
  user_name_is_not_composite: TRANSLATION.feedback.save.usernameIsntComposite,
  invalid_current_password: TRANSLATION.feedback.update.invalidCurrentPassword,
  address_not_found: TRANSLATION.feedback.update.addressNotFound,
  validation_error: TRANSLATION.feedback.save.validationError,
  default: TRANSLATION.feedback.error
}

export default {
  name: 'UsersManage',
  directives: { mask },
  components: {
    Tabs: () => import('@/components/general/Tabs'),
    Radio: () => import('@/components/general/Radio'),
    Modal: () => import('@/components/general/Modal'),
    Action: () => import('@/components/general/Action'),
    Checkbox: () => import('@/components/general/Checkbox'),
    Datepicker: () => import('@/components/general/Datepicker'),
    InputField: () => import('@/components/general/InputField'),
    FormSection: () => import('@/components/general/FormSection'),
    SelectField: () => import('@/components/general/SelectField'),
    Autocomplete: () => import('@/components/general/Autocomplete')
  },

  data () {
    return {
      selectedProfile: null,
      formData: {
        id: null,
        name: null,
        email: null,
        username: null,
        gender: null,
        educationLevelId: null,
        entrepreneurProfileId: null,
        entrepreneurProfile: {
          entrepreneurProfileQuestion: null
        },

        entrepreneurProfileQuestion: [],
        data: {
          celular: null,
          birthOfDate: null,
          gender: null,
          notificationType: {
            correio: false,
            email: true,
            sms: false,
            telefone: false
          },

          address: {
            pais: 'BR',
            id_state: '',
            uf: null,
            id_city: null,
            cidade: null,
            bairro: null,
            cep: '',
            logradouro: null,
            tipo_logradouro: null,
            numero: null,
            complemento: null,
            IdTipoLogradouro: 1001
          }
        },

        company: {
          id: null,
          cnpj: '',
          companyName: null,
          tradingName: null,
          foundingDate: null,
          phone: null,
          situation_alias: null,
          businessSectorIds: [],
          businessSizeId: null,
          cnaeIds: [],
          data: {
            address: {
              pais: 'BR',
              id_state: '',
              uf: null,
              id_city: null,
              cidade: null,
              bairro: null,
              cep: '',
              logradouro: null,
              tipo_logradouro: null,
              numero: null,
              complemento: null,
              IdTipoLogradouro: 1001
            }
          }
        },

        currentPassword: null,
        newPassword: null,
        confirmPassword: null
      },

      personSituationOptions: [
        {
          label: this.$t('users.manage:company.situation.company_owner'),
          value: 'company_owner'
        },
        {
          label: this.$t('users.manage:company.situation.natural_person'),
          value: 'natural_person'
        }
      ],

      genderOptions: [
        {
          text: this.$t('global.genre:FEMALE'),
          value: 'F'
        },
        {
          text: this.$t('global.genre:MALE'),
          value: 'M'
        }
      ],

      notificationOptions: {
        email: [
          {
            label: this.$t('global:form.email'),
            value: false
          }
        ],

        telefone: [
          {
            label: this.$t('global:form.phone'),
            value: false
          }
        ],

        correio: [
          {
            label: this.$t('global:form.mail'),
            value: false
          }
        ],

        sms: [
          {
            label: this.$t('global:form.sms'),
            value: false
          }
        ]
      },

      educationLevels: [],
      entrepreneurProfiles: [],
      states: [],
      userCities: [],
      companyCities: [],
      currentCep: '',
      businessSectors: [],
      businessSizes: [],
      cnaes: [],
      profileOptions: [
        {
          label: 'Administrador',
          value: 'admin'
        },
        {
          label: 'Estudante',
          value: 'user'
        }
      ],

      tabLinks: [
        {
          text: 'community.index:modal.tab.link.personal.data'
        }
      ],

      tabLinkActive: 0,
      allowChangeTab: true,
      userEntrepreneurProfile: null
    }
  },

  validations: {
    formData: {
      id: {
        required: requiredIf(function () {
          return this.isEditing
        })
      },

      name: { required },
      email: {
        required,
        email
      },

      username: {
        required,
        cpfValidation: minLength(14)
      },

      educationLevelId: {
        required: requiredIf(function () {
          return this.isEditing
        })
      },

      entrepreneurProfileId: {
        required: requiredIf(function () {
          return this.isEditing
        })
      },

      entrepreneurProfile: {
        entrepreneurProfileQuestion: {
          $each: {
            required: requiredIf(function (item) {
              return this.formData.entrepreneurProfile && item.required
            }),

            value: {
              required: requiredIf(function (item) {
                return this.formData.entrepreneurProfile && item.required
              })
            }
          }
        }
      },

      data: {
        celular: {
          required: requiredIf(function () {
            return this.isEditing
          }),

          phoneValidation: function (item) {
            if (this.isEditing) {
              return phoneValidator(item)
            }

            return true
          }
        },

        birthOfDate: {
          required: requiredIf(function () {
            return this.isEditing
          }),

          birthday: minLength(10)
        },

        gender: {
          required: requiredIf(function () {
            return this.isEditing
          })
        },

        address: {
          id_state: {
            required: requiredIf(function () {
              return this.isEditing
            })
          },

          id_city: {
            required: requiredIf(function () {
              return this.isEditing
            })
          },

          bairro: {
            required: requiredIf(function () {
              return this.isEditing
            })
          },

          logradouro: {
            required: requiredIf(function () {
              return this.isEditing
            })
          },

          numero: {
            required: requiredIf(function () {
              return this.isEditing
            })
          },

          cep: {
            required: requiredIf(function () {
              return this.isEditing
            }),

            minLength: minLength(9)
          }
        }
      },

      company: {
        cnpj: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          }),

          cnpjValidation: function (value) {
            if (!this.canReleaseCompanyFields()) return true

            return cnpjValidator(value)
          },

          minLength: minLength(18)
        },

        companyName: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        tradingName: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        foundingDate: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        phone: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          }),

          phoneValidation: function (item) {
            if (!this.canReleaseCompanyFields()) return true

            return phoneValidator(item)
          }
        },

        situation_alias: { required },
        businessSectorIds: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        businessSizeId: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        cnaeIds: {
          required: requiredIf(function () {
            return this.canReleaseCompanyFields()
          })
        },

        data: {
          address: {
            id_state: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              })
            },

            id_city: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              })
            },

            bairro: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              })
            },

            logradouro: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              })
            },

            numero: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              })
            },

            cep: {
              required: requiredIf(function () {
                return this.canReleaseCompanyFields()
              }),

              minLength: minLength(9)
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapState([ 'fetching' ]),
    isEditing () {
      return this.$store.getters.getManagingUser || this.$route.params.id || false
    },

    hasStudentProfile () {
      return (this.formData.profile && this.formData.profile.find(item => item === 'user')) || true
    },

    parsedEntrepreneurProfiles () {
      return this.entrepreneurProfiles.map(item => {
        return {
          text: item.name,
          value: item.id
        }
      })
    }
  },

  watch: {
    'formData.company.situation_alias' () {
      if (this.formData.company.situation_alias === 'company_owner') {
        this.tabLinks.push(
          {
            text: 'community.index:modal.tab.link.corporate.data'
          }
        )

        this.getCompanySelectsData()

        if (this.allowChangeTab) {
          this.tabLinkActive = 1

          this.debounceEvent(() => {
            document.querySelector('.modal-blocker')
              .scroll({
                top: 0,
                behavior: 'smooth'
              })
          }, 500)
        }
      } else if (this.tabLinks.length === 2) {
        this.tabLinks.pop()
      }

      this.allowChangeTab = true
    },

    'formData.data.address.cep' () {
      const newCep = this.formData.data.address.cep.replace(/[^0-9]+/ig, '')

      if (newCep === this.currentCep.replace(/[^0-9]+/ig, '')) {
        return
      }

      if (newCep.length === 8) {
        this.getUserAddressByCep()
        this.currentCep = newCep
      }
    },

    'formData.company.data.address.cep' () {
      if (this.formData.company.data.address.cep.length === 9) {
        this.getCompanyAddressByCep()
      }
    },

    'formData.data.address.id_state' () {
      this.ListCitiesByState(this.formData.data.address.id_state, 'user')
    },

    'formData.company.data.address.id_state' () {
      this.ListCitiesByState(this.formData.company.data.address.id_state, 'company')
    },

    'formData.company.cnpj' () {
      if (this.formData.company.cnpj.length === 18) {
        this.formData.company.id = null
        this.getCompanyDataByCnpj()
      }
    },

    'formData.username' () {
      if (!this.isEditing && this.formData.username.length === 14) {
        this.getUserDataByCpf()
      }
    },

    'formData.entrepreneurProfileId' (newVal) {
      if (!this.formData.entrepreneurProfileId) {
        return
      }

      this.formData.entrepreneurProfile = this.userEntrepreneurProfile

      if (this.formData.entrepreneurProfile?.id !== newVal) {
        const selectedEntrepreneurProfile = this.entrepreneurProfiles.filter(profile => {
          return profile.id === this.formData.entrepreneurProfileId ? profile : null
        })

        this.formData.entrepreneurProfile = selectedEntrepreneurProfile && selectedEntrepreneurProfile.length > 0
          ? selectedEntrepreneurProfile[0]
          : null
      }

      if (!this.formData.entrepreneurProfile) {
        return
      }

      const question = this.formData.entrepreneurProfile.entrepreneurProfileQuestion

      this.formData.entrepreneurProfile.entrepreneurProfileQuestion = question.map((question) => {
        return {
          id: question.id,
          title: question.title,
          type: question.type,
          required: question.required,
          value: this.getEntrepreneurValue(question.entrepreneurProfileAnswer),
          entrepreneurProfileQuestionOption: question.entrepreneurProfileQuestionOption.map(item => {
            if (item.name) {
              return {
                text: item.name,
                value: item.name
              }
            }

            return item
          })
        }
      })
    }
  },

  created () {
    this.setup()
    this.getSelectsData()

    if (this.isEditing) {
      this.loadUserData()
    }
  },

  methods: {
    ...mapActions([
      'setFetching',
      'setFeedback',
      'attemptUpdateUser',
      'attemptGetUser',
      'attemptGetAddressByCep',
      'attemptListEducationLevels',
      'attemptListStates',
      'attemptListCities',
      'attemptListBusinessSectors',
      'attemptListBusinessSizes',
      'attemptListCnaes',
      'attemptGetCompanyDataByCnpj',
      'attemptCreateUser',
      'attemptGetUserByCpf',
      'attemptListEntrepreneurProfiles'
    ]),

    setup () {
      this.TRANSLATION = TRANSLATION
      this.CREATE_ERRORS_TYPE = CREATE_ERRORS_TYPE
      this.UPDATE_ERRORS_TYPE = UPDATE_ERRORS_TYPE
    },

    changeTab (index) {
      this.tabLinkActive = index
    },

    submit () {
      if (this.isEditing) {
        this.updateUser()

        return
      }

      this.createUser()
    },

    updateUser () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.showValidationErrors()

        return
      }

      this.setFetching(true)
      const formData = this.parseUserRequestData()

      this.attemptUpdateUser(formData)
        .then(() => {
          this.setFeedback({ message: TRANSLATION.feedback.update.success })
          this.leave()
        })
        .catch((response) => {
          const error = response.data.error

          if (UPDATE_ERRORS_TYPE[error.message]) {
            this.setFeedback({ message: UPDATE_ERRORS_TYPE[error.message] })

            return
          }

          this.setFeedback({ message: UPDATE_ERRORS_TYPE.default })
        })
        .finally(() => {
          this.setFetching(false)
        })
    },

    createUser () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.showValidationErrors()

        return
      }

      this.setFetching(true)
      const formData = this.parseUserRequestData()

      this.attemptCreateUser(formData)
        .then(() => {
          this.setFeedback({ message: TRANSLATION.feedback.create.success })
          this.leave()
        })
        .catch((response) => {
          const error = response.data.error

          if (CREATE_ERRORS_TYPE[error.message]) {
            this.setFeedback({ message: CREATE_ERRORS_TYPE[error.message] })

            return
          }

          this.setFeedback({ message: CREATE_ERRORS_TYPE.default })
        })
        .finally(() => {
          this.setFetching(false)
        })
    },

    parseUserRequestData () {
      const formData = JSON.parse(JSON.stringify(this.formData))

      formData.username = formData.username.replace(/[^0-9]+/ig, '')
      formData.isAdmin = true

      formData.data = Object.fromEntries(Object.entries(formData.data)
        .filter(([ value ]) => !!value))

      if (this.formData.data.address.id_state) {
        const state = this.states.find(element =>
          element.value === this.formData.data.address.id_state
        )

        formData.data.address.uf = state.text
      }

      if (this.formData.data.address.id_city) {
        const city = this.userCities.find(element =>
          element.value === this.formData.data.address.id_city
        )

        formData.data.address.cidade = city?.text
      }

      if (!this.canReleaseCompanyFields()) {
        formData.company = null

        return formData
      }

      formData.company.cnpj = sanitizeCnpj(formData.company.cnpj)
      const cnaes = []

      formData.company.cnaeIds.forEach(item => {
        cnaes.push(item.code)
      })

      formData.company.cnaeIds = cnaes

      const companyState = this.states.find(element =>
        element.value === this.formData.company.data.address.id_state
      )
      const companyCity = this.companyCities.find(element =>
        element.value === this.formData.company.data.address.id_city
      )

      formData.company.data.address.uf = companyState.text
      formData.company.data.address.cidade = companyCity?.text

      return formData
    },

    showValidationErrors () {
      this.$nextTick(() => {
        if (this.tabLinks.length === 2 && this.tabLinkActive === 0 && this.$v.formData.company.$error) {
          this.tabLinkActive = 1
        }

        if (this.tabLinkActive === 1 && !this.$v.formData.company.$error && this.$v.formData.$error) {
          this.tabLinkActive = 0
        }

        this.setFeedback({ message: this.$t('users.manage:validation.error') })

        this.debounceEvent(() => {
          const hasErrorElements = document.querySelector('.has-error')
          const top = hasErrorElements.offsetTop - 50

          document.querySelector('.modal-blocker')
            .scroll({
              top: top,
              behavior: 'smooth'
            })
        }, 500)
      })
    },

    leave () {
      this.$router.push({
        name: 'users.index',
        params: { searchUserBind: this.$route.params.searchUserBind }
      })
    },

    canReleaseCompanyFields () {
      return [
        'company_owner',
        'company_employee'
      ].includes(this.formData.company.situation_alias)
    },

    getUserAddressByCep () {
      let cep = this.formData.data.address.cep

      cep = cep.replace(/[^0-9]+/ig, '')

      if (cep.length === 8) {
        this.attemptGetAddressByCep(cep)
          .then(({ data }) => {
            this.formData.data.address.id_state = data.CityObject.state.id
            this.formData.data.address.logradouro = data.Logradouro
            this.formData.data.address.bairro = data.Bairro
            this.formData.data.address.IdTipoLogradouro = data.IdTipoLogradouro
            this.formData.data.address.id_city = data.CityObject.id
          })
          .catch(({ data }) => {
            let message = this.$t('global:form.user.manage.validation.cep.not.found')

            if (data && data.error.message === 'address_not_found') {
              message = this.$t('global:form.user.manage.validation.cep.address.not.found')
            } else if (data && data.error.message === 'city_not_found') {
              message = this.$t('global:form.user.manage.validation.cep.city.not.found')
            }

            this.setFeedback({ message: message })
          })
      }
    },

    getCompanyAddressByCep () {
      let cep = this.formData.company.data.address.cep

      cep = cep.replace(/[^0-9]+/ig, '')

      if (cep.length === 8) {
        this.attemptGetAddressByCep(cep)
          .then(({ data }) => {
            this.formData.company.data.address.id_state = data.CityObject.state.id ?? this.formData.company.data.address.id_state
            this.formData.company.data.address.logradouro = data.Logradouro ?? this.formData.company.data.address.logradouro
            this.formData.company.data.address.bairro = data.Bairro ?? this.formData.company.data.address.bairro
            this.formData.company.data.address.IdTipoLogradouro = data.IdTipoLogradouro ?? this.formData.company.data.address.IdTipoLogradouro
            this.formData.company.data.address.id_city = data.CityObject.id ?? this.formData.company.data.address.id_city
          })
      }
    },

    getSelectsData () {
      this.attemptListEducationLevels()
        .then(({ data }) => {
          data.forEach(item => {
            this.educationLevels.push({
              text: item.description,
              value: item.id
            })
          })
        })

      this.attemptListStates()
        .then(({ data }) => {
          data.forEach(item => {
            this.states.push({
              text: item.name,
              value: item.id
            })
          })
        })

      this.attemptListEntrepreneurProfiles({
        filter: { active: 1 },
        order: {
          name: 'ASC',
          alias: 'ASC'
        },
        limit: 999999
      })
        .then(({ data }) => {
          data.forEach(item => {
            this.entrepreneurProfiles.push(item)
          })
        })
    },

    getCompanySelectsData () {
      this.attemptListBusinessSectors()
        .then(({ data }) => {
          this.businessSectors = []

          data.forEach(item => {
            this.businessSectors.push({
              text: item.description,
              value: item.id
            })
          })
        })

      this.attemptListBusinessSizes()
        .then(({ data }) => {
          this.businessSizes = []

          data.forEach(item => {
            this.businessSizes.push({
              text: item.description,
              value: item.id
            })
          })
        })
    },

    ListCitiesByState (stateId, context) {
      this.attemptListCities(stateId)
        .then(({ data }) => {
          if (!data) {
            return
          }

          const cities = []

          data.forEach(item => {
            cities.push({
              text: item.name,
              value: item.id
            })
          })

          if (context === 'user') {
            this.userCities = cities
          }

          if (context === 'company') {
            this.companyCities = cities
          }
        })
    },

    fetchCnaes (search) {
      if (search.length < 3) {
        return
      }

      const options = []

      this.attemptListCnaes(search)
        .then(({ data }) => {
          data.data.forEach(item => {
            const description = item.cnaeCode + ' - ' + item.description

            options.push({
              label: description,
              code: item.id
            })
          })
        })

      this.cnaes = options
    },

    getCompanyDataByCnpj () {
      const cnpj = sanitizeCnpj(this.formData.company.cnpj)

      if (cnpj.length === 14) {
        this.attemptGetCompanyDataByCnpj(cnpj)
          .then(({ data }) => {
            this.formData.company.id = data.id
            this.formData.company.companyName = data.companyName
            this.formData.company.tradingName = data.tradingName

            if (data.foundingDate) {
              this.formData.company.foundingDate = data.foundingDate
            }

            this.formData.company.phone = data.phone
            this.formData.company.businessSizeId = data.businessSize ? data.businessSize.id : null
            this.formData.company.businessSectorIds = []

            data.companyBusinessSectors.forEach(item => {
              this.formData.company.businessSectorIds.push(item.businessSector.id)
            })

            this.formData.company.cnaeIds = []
            this.cnaes = []

            data.companyCnaes.forEach(item => {
              const description = item.cnae.cnaeCode + ' - ' + item.cnae.description
              const cnaeId = item.cnae.id

              this.cnaes.push({
                label: description,
                code: cnaeId
              })

              this.formData.company.cnaeIds.push({
                label: description,
                code: cnaeId
              })
            })

            this.formData.company.data.address.cep = data.data.address.cep
            this.formData.company.data.address.id_state = parseInt(data.data.address.id_state)
            this.formData.company.data.address.id_city = parseInt(data.data.address.id_city)
            this.formData.company.data.address.bairro = data.data.address.bairro
            this.formData.company.data.address.logradouro = data.data.address.logradouro
            this.formData.company.data.address.numero = data.data.address.numero
            this.formData.company.data.address.complemento = data.data.address.complemento
          })
      }
    },

    parseUserResponseData (data) {
      this.formData.id = data.user.id

      if (this.isEditing) {
        this.formData.username = data.user.username
      }

      this.formData.name = data.user.name
      this.formData.email = data.user.email
      this.formData.data.birthOfDate = data.user.data.birthOfDate
      this.formData.data.celular = data.user.data.celular
      this.formData.data.gender = data.user.data.gender

      if (data.user.educationLevel) {
        this.formData.educationLevelId = data.user.educationLevel.id
      }

      if (data.user.entrepreneurProfile) {
        this.userEntrepreneurProfile = data.user.entrepreneurProfile
        this.formData.entrepreneurProfileId = this.userEntrepreneurProfile.id
      }

      if (data.user.data.notificationType) {
        const notification = data.user.data.notificationType

        this.formData.data.notificationType = {
          email: notification.email,
          telefone: notification.telefone,
          correio: notification.correio,
          sms: notification.sms
        }
      }

      if (data.user.data.address) {
        this.formData.data.address.cep = this.currentCep = data.user.data.address.cep
        this.formData.data.address.id_state = parseInt(data.user.data.address.id_state)
        this.formData.data.address.id_city = parseInt(data.user.data.address.id_city)
        this.formData.data.address.bairro = data.user.data.address.bairro
        this.formData.data.address.logradouro = data.user.data.address.logradouro
        this.formData.data.address.numero = data.user.data.address.numero
        this.formData.data.address.complemento = data.user.data.address.complemento
      }

      this.allowChangeTab = false
      this.formData.company.situation_alias = data.situation ? data.situation.alias : 'natural_person'

      if (this.canReleaseCompanyFields()) {
        this.formData.company.cnpj = data.company.cnpj
      }
    },

    loadUserData () {
      this.attemptGetUser(this.$route.params.id)
        .then(({ data }) => {
          this.parseUserResponseData(data)
        })
        .catch(() => {
          this.setFeedback({ message: this.$t('users.manage:error.user.not.found') })
          this.$router.push({ name: 'users.index' })
        })
    },

    getUserDataByCpf () {
      this.attemptGetUserByCpf(this.formData.username.replace(/[^0-9]+/ig, ''))
        .then(({ data }) => {
          this.parseUserResponseData(data)
        })
        .catch(({ data }) => {
          if (data && data.error.message === 'user_already_registered') {
            this.formData.username = null
            this.setFeedback({ message: this.$t('users.manage:error.already.registered') })
          }
        })
    },

    yesterday () {
      const date = new Date()

      date.setDate(date.getDate() - 1)

      return date.toISOString()
        .slice(0, 10)
    },

    getEntrepreneurValue (entrepreneurProfileAnswer) {
      if (entrepreneurProfileAnswer && entrepreneurProfileAnswer.length && entrepreneurProfileAnswer.length > 0) {
        return entrepreneurProfileAnswer[0].text
      }

      return null
    }
  }

}
</script>

<template>
  <Modal
    :active="!fetching"
    prevent-e-s-c
    @close="leave()"
  >
    <div class="modal-form modal-add-user">
      <span class="modal-subtitle">{{ $t('community:modal.subtitle') }}</span>
      <h2 class="modal-title">
        {{ isEditing ? $t('community.index:modal.title.editing') :$t('community.index:modal.title.add') }}
      </h2>
      <Tabs
        v-if="hasStudentProfile"
        slot="tabs"
        :links="tabLinks"
        :index-active="tabLinkActive"
        dark
        @tabChange="changeTab($event)"
      />
      <form @submit.prevent="submit()">
        <div v-show="tabLinkActive === 0">
          <InputField
            v-model="formData.username"
            :label="$t('global:form.cpf')"
            mask="###.###.###-##"
            :validation="$v.formData.username"
            :readonly="!!isEditing"
            dark
          />
          <Datepicker
            v-model="formData.data.birthOfDate"
            :label="$t('global:form.birthday')"
            :validation="$v.formData.data.birthOfDate"
            min="1920-01-01"
            :max="yesterday()"
            dark
          />
          <InputField
            v-model="formData.name"
            :label="$t('global:form.full.name')"
            autocomplete="name"
            :validation="$v.formData.name"
            dark
          />
          <InputField
            v-model="formData.email"
            :label="$t('global:form.email')"
            autocomplete="email"
            :validation="$v.formData.email"
            dark
          />
          <InputField
            v-model="formData.data.celular"
            :label="$t('global:form.phone')"
            mask="(##) #####-####"
            autocomplete="email"
            :validation="$v.formData.data.celular"
            dark
          />
          <SelectField
            v-model="formData.data.gender"
            :label="$t('global:form.gender')"
            :items="genderOptions"
            :validation="$v.formData.data.gender"
            dark
          />
          <SelectField
            v-model="formData.educationLevelId"
            :label="$t('global:form.education.level')"
            :items="educationLevels"
            :validation="$v.formData.educationLevelId"
            dark
          />
          <SelectField
            v-model="formData.entrepreneurProfileId"
            :label="$t('global:form.entrepreneur.profile')"
            :items="parsedEntrepreneurProfiles"
            :validation="$v.formData.entrepreneurProfileId"
            dark
          />
          <div
            v-if="formData.entrepreneurProfile &&
              formData.entrepreneurProfile.entrepreneurProfileQuestion &&
              formData.entrepreneurProfile.entrepreneurProfileQuestion.length > 0"
            dark
          >
            <div
              v-for="(field, fieldIndex) in formData.entrepreneurProfile.entrepreneurProfileQuestion"
              :key="fieldIndex"
            >
              <InputField
                v-if="field.type === 'text'"
                v-model="field.value"
                :label="'Campo extra: ' + field.title"
                :validation="$v.formData.entrepreneurProfile.entrepreneurProfileQuestion.$each[fieldIndex].value"
                dark
              />
              <SelectField
                v-else-if="field.type === 'unique'"
                v-model="field.value"
                :label="'Campo extra: ' + field.title"
                :validation="$v.formData.entrepreneurProfile.entrepreneurProfileQuestion.$each[fieldIndex].value"
                :items="field.entrepreneurProfileQuestionOption"
                dark
              />
            </div>
          </div>
          <InputField
            v-model="formData.data.address.cep"
            :label="$t('global:form.cep')"
            mask="#####-###"
            :validation="$v.formData.data.address.cep"
            dark
          />
          <InputField
            v-model="formData.data.address.logradouro"
            :label="$t('global:form.street')"
            :validation="$v.formData.data.address.logradouro"
            dark
          />
          <InputField
            v-model="formData.data.address.numero"
            :label="$t('global:form.number')"
            :validation="$v.formData.data.address.numero"
            dark
          />
          <InputField
            v-model="formData.data.address.complemento"
            :label="$t('global:form.complement')"
            :validation="$v.formData.data.address.complemento"
            dark
          />
          <SelectField
            v-model="formData.data.address.id_state"
            :label="$t('global:form.state')"
            :items="states"
            :validation="$v.formData.data.address.id_state"
            dark
          />
          <SelectField
            v-model="formData.data.address.id_city"
            :label="$t('global:form.city')"
            :items="userCities"
            :validation="$v.formData.data.address.id_city"
            dark
          />
          <InputField
            v-model="formData.data.address.bairro"
            :label="$t('global:form.neighborhood')"
            :validation="$v.formData.data.address.bairro"
            dark
          />

          <FormSection :title="$t('users.manage:company.situation')">
            <Radio
              v-model="formData.company.situation_alias"
              :items="personSituationOptions"
              :validation="$v.formData.company.situation_alias"
              dark
            />
          </FormSection>
          <FormSection :title="$t('users.manage:notification.type')">
            <Checkbox
              v-model="formData.data.notificationType.correio"
              :items="notificationOptions.correio"
              switch-type
              dark
            />
            <Checkbox
              v-model="formData.data.notificationType.email"
              :items="notificationOptions.email"
              switch-type
              dark
            />
            <Checkbox
              v-model="formData.data.notificationType.sms"
              :items="notificationOptions.sms"
              switch-type
              dark
            />
            <Checkbox
              v-model="formData.data.notificationType.telefone"
              :items="notificationOptions.telefone"
              switch-type
              dark
            />
          </FormSection>
        </div>
        <div v-show="tabLinkActive === 1">
          <InputField
            v-model="formData.company.cnpj"
            :label="$t('global:form.cnpj')"
            mask="##.###.###/####-##"
            alphanumeric
            autocomplete="username"
            :validation="$v.formData.company.cnpj"
            dark
          />
          <InputField
            v-model="formData.company.companyName"
            :label="$t('global:form.social.name')"
            autocomplete="name"
            :validation="$v.formData.company.companyName"
            dark
          />
          <InputField
            v-model="formData.company.tradingName"
            :label="$t('global:form.fantasy.name')"
            autocomplete="name"
            :validation="$v.formData.company.tradingName"
            dark
          />
          <Datepicker
            v-model="formData.company.foundingDate"
            :label="$t('global:form.foundation.date')"
            :validation="$v.formData.company.foundingDate"
            min="1900-01-01"
            :max="yesterday()"
            dark
          />
          <InputField
            v-model="formData.company.phone"
            :label="$t('global:form.phone')"
            :mask="['(##) ####-####', '(##) #####-####']"
            autocomplete="email"
            :validation="$v.formData.company.phone"
            dark
          />
          <InputField
            v-model="formData.company.data.address.cep"
            :label="$t('global:form.cep')"
            mask="#####-###"
            :validation="$v.formData.company.data.address.cep"
            dark
          />
          <InputField
            v-model="formData.company.data.address.logradouro"
            :label="$t('global:form.street')"
            :validation="$v.formData.company.data.address.logradouro"
            dark
          />
          <InputField
            v-model="formData.company.data.address.numero"
            :label="$t('global:form.number')"
            :validation="$v.formData.company.data.address.numero"
            dark
          />
          <InputField
            v-model="formData.company.data.address.complemento"
            :label="$t('global:form.complement')"
            :validation="$v.formData.company.data.address.complemento"
            dark
          />
          <SelectField
            v-model="formData.company.data.address.id_state"
            :label="$t('global:form.state')"
            :items="states"
            :validation="$v.formData.company.data.address.id_state"
            dark
          />
          <SelectField
            v-model="formData.company.data.address.id_city"
            :label="$t('global:form.city')"
            :items="companyCities"
            :validation="$v.formData.company.data.address.id_city"
            dark
          />
          <InputField
            v-model="formData.company.data.address.bairro"
            :label="$t('global:form.neighborhood')"
            :validation="$v.formData.company.data.address.bairro"
            dark
          />
          <SelectField
            v-model="formData.company.businessSectorIds"
            :label="$t('global:form.business.sector')"
            :items="businessSectors"
            :validation="$v.formData.company.businessSectorIds"
            multiple
            dark
          />
          <SelectField
            v-model="formData.company.businessSizeId"
            :label="$t('global:form.business.size')"
            :items="businessSizes"
            :validation="$v.formData.company.businessSizeId"
            dark
          />
          <Autocomplete
            v-model="formData.company.cnaeIds"
            label="Tipo de empreendimento (CNAE)"
            :items="cnaes"
            async
            class="cnae-field"
            option-property="label"
            :max-value="9999"
            :validation="$v.formData.company.cnaeIds"
            dark
            multiple
            @search="fetchCnaes"
          />
        </div>
        <div class="form-submit text-center">
          <Action
            :text="isEditing ? $t('global:save') : $t('global:register')"
            type="button"
            secondary
            large
            submit
            fixed-width
          />
        </div>
      </form>
    </div>
  </Modal>
</template>

<style>
  .profiles-selection {
    margin-top: 60px;
  }
</style>
